import { render } from "./OidoToolbar.vue?vue&type=template&id=5f25902a&scoped=true"
import script from "./OidoToolbar.vue?vue&type=script&lang=js"
export * from "./OidoToolbar.vue?vue&type=script&lang=js"

import "./OidoToolbar.vue?vue&type=style&index=0&id=5f25902a&scoped=true&lang=css"
import "./OidoToolbar.vue?vue&type=style&index=1&id=5f25902a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f25902a"]])

export default __exports__